import React, { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import DatePicker from "react-datepicker";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

function DACalculator() {
  const [formData, setFormData] = useState({
    name: "",
    baseSalary: "",
    currentDA: "",
    revisedDA: "",
    differenceMonths: "",
  });
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  const [showResult, setShowResult] = useState(false);
  const [result, setResult] = useState({
    monthlyDADifference: 0,
    totalDADifference: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const calculateDA = () => {
    const fromDates = moment(fromDate, "YYYY-MM");
    const toDates = moment(toDate, "YYYY-MM");

    const value = toDates.diff(fromDates, "months") + 1;

    setFormData({ ...formData, ["differenceMonths"]: value });

    const baseSalary = parseFloat(formData.baseSalary) || 0;
    const currentDA = parseFloat(formData.currentDA) || 0;
    const revisedDA = parseFloat(formData.revisedDA) || 0;
    const differenceMonths = parseInt(value) || 0;

    const startDate = moment(fromDate, "YYYY-MM-DD");
    const endDate = moment(toDate, "YYYY-MM-DD");
    // const differenceMonths = endDate.diff(startDate, "months") + 1;

    // Calculate DA differences based on the salary
    const monthlyOldDA = (baseSalary * currentDA) / 100; // Old DA
    const monthlyNewDA = (baseSalary * revisedDA) / 100; // New DA
    const monthlyDADifference = monthlyNewDA - monthlyOldDA; // Difference

    // Prepare table data for each month
    const tableData = [];
    let tempDate = moment(startDate); // Initialize with start date
    for (let i = 1; i <= differenceMonths; i++) {
      tableData.push({
        month: tempDate.format("MMM YYYY"), // Display Month and Year (e.g., Jan 2024)
        oldDA: Math.round(monthlyOldDA),
        newDA: Math.round(monthlyNewDA),
        difference: Math.round(monthlyDADifference),
      });
      tempDate.add(1, "months"); // Move to the next month
    }

    // Set results
    setResult({ tableData });
    setShowResult(true);
  };

  const generatePDF = () => {
    const input = document.getElementById("DAResult"); // The div you want to convert into a PDF

    html2canvas(input, {
      backgroundColor: "#ffffff", // Ensures white background
      scale: 2, // Improves quality
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      // Create PDF in A4 size (portrait)
      const pdf = new jsPDF("p", "mm", "a4");

      // Calculate 1/4 size of A4 dimensions
      const fullWidth = pdf.internal.pageSize.getWidth(); // A4 width
      const fullHeight = pdf.internal.pageSize.getHeight(); // A4 height

      const quarterWidth = fullWidth / 2; // Half width
      const quarterHeight = fullHeight / 2; // Half height

      // Margins for placement inside the 1/4 size
      const marginLeft = 15; // Margin from left
      const marginTop = 15; // Margin from top

      // Resize the image to fit within 1/4 size
      const imgWidth = quarterWidth - 10; // Padding of 5mm on both sides
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

      // Add the image into the PDF at the specified position and size
      pdf.addImage(imgData, "PNG", marginLeft, marginTop, imgWidth, imgHeight);

      // Save the PDF file
      pdf.save(`${formData.name}_dacalci.pdf`);
    });
  };

  return (
    <div>
      <Header />

      <div className="container mx-auto py-10">
        <div className="row">
          <div className="col-lg-8 m-auto">
            <div className="row">
              <div className="col-lg-5">
                {/* Form Section */}
                <div className="bg-white p-3 rounded shadow w-full">
                  <h2 className="text-xl md:text-2xl font-bold text-blue-600 mb-4">
                    Calculate DA Difference
                  </h2>
                  <form className="text-left">
                    <div className="mb-2">
                      <label className="block pb-2 text-gray-700 text-sm md:text-base">
                        आपले नाव
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block pb-2 text-gray-700 text-sm md:text-base">
                        मूळ वेतन
                      </label>
                      <input
                        type="number"
                        name="baseSalary"
                        value={formData.baseSalary}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block pb-2 text-gray-700 text-sm md:text-base">
                        सध्याचा महागाई भत्ता (%)
                      </label>
                      <input
                        type="number"
                        name="currentDA"
                        value={formData.currentDA}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block pb-2 text-gray-700 text-sm md:text-base">
                        सुधारित महागाई भत्ता (%)
                      </label>
                      <input
                        type="number"
                        name="revisedDA"
                        value={formData.revisedDA}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="mb-3">
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="block pb-2 text-gray-700 text-sm md:text-base">
                            {/* फरक काढायचे महिने */}
                            महिना (पासून)
                          </label>
                          <DatePicker
                            selected={fromDate}
                            onChange={(date) => setFromDate(date)}
                            dateFormat="MMM-yyyy" // Built-in format for DD-MMM-YYYY
                            className="form-control"
                            showMonthDropdown // Enables month dropdown
                            showYearDropdown // Enables year dropdown
                            dropdownMode="select" // Allows selection instead of scrolling
                            showMonthYearPicker // Enables Month-Year Picker
                            showFullMonthYearPicker // Optional: Shows full month and year in the dropdown
                          />
                          {/* <input
                            type="number"
                            name="differenceMonths"
                            value={formData.frommonth}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded"
                          /> */}
                        </div>
                        <div className="col-lg-6">
                          <label className="block pb-2 text-gray-700 text-sm md:text-base">
                            {/* फरक काढायचे महिने */}
                            महिना (पर्यंत)
                          </label>
                          <DatePicker
                            selected={toDate}
                            onChange={(date) => setToDate(date)}
                            dateFormat="MMM-yyyy" // Built-in format for DD-MMM-YYYY
                            className="form-control"
                            showMonthDropdown // Enables month dropdown
                            showYearDropdown // Enables year dropdown
                            dropdownMode="select" // Allows selection instead of scrolling
                            showMonthYearPicker // Enables Month-Year Picker
                            showFullMonthYearPicker // Optional: Shows full month and year in the dropdown
                          />
                          {/* <input
                            type="number"
                            name="differenceMonths"
                            value={formData.frommonth}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded"
                          /> */}
                        </div>
                      </div>
                    </div>
                    <div className="text-center mt-2">
                      <button
                        type="button"
                        onClick={calculateDA}
                        className="btn btn-primary"
                      >
                        Calculate DA Diff
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-lg-7">
                {/* Result Section  ${showResult ? 'block' : 'hidden'} */}
                <div
                  className={`bg-white p-3 rounded shadow w-full`}
                  id="DAResult"
                >
                  <h2 className="text-base md:text-2xl font-bold text-red-600 mb-2">
                    DA Calculation
                  </h2>
                  <div className="mb-3">
                    <p className="text-black mb-2 font-semibold">
                      आपले नाव : {formData.name}
                    </p>
                  </div>

                  <div className="mb-3">
                    <p className="text-black mb-2 font-semibold">
                      मूळ वेतन : {formData.baseSalary}
                    </p>
                  </div>
                  <div className="row px-0">
                    <div className="col-lg-6 px-0">
                      <label className="text-black mb-2 font-semibold">
                        महिना(पासून) :{" "}
                        {fromDate && moment(fromDate).format("MMM-YYYY")}
                      </label>
                    </div>
                    <div className="col-lg-6 px-0">
                      <label className="text-black mb-2 font-semibold">
                        महिना(पर्यंत) :{" "}
                        {toDate && moment(toDate).format("MMM-YYYY")}
                      </label>
                    </div>
                    <div className="col-lg-12 mt-2 px-0">
                      {showResult && (
                        <div className="table-responsive overflow-auto">
                          <table className="table table-bordered table-stripped">
                            <thead>
                              <tr className="headingRow">
                                <th>महिना </th>
                                <th className="text-center p-1">
                                  <small>
                                    {" "}
                                    सध्याचा महागाई भत्ता {formData.currentDA}%
                                  </small>
                                </th>
                                <th className="text-center p-1">
                                  <small>
                                    सुधारित महागाई भत्ता {formData.revisedDA}%
                                  </small>
                                </th>
                                <th>फरक</th>
                              </tr>
                            </thead>
                            <tbody>
                              {result.tableData.map((row, index) => (
                                <tr key={index}>
                                  <td className="flex-nowrap">{row.month}</td>
                                  <td className="text-center">{row.oldDA}</td>
                                  <td className="text-center">{row.newDA}</td>
                                  <td className="text-center">
                                    {row.difference}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot>
                              <tr>
                                <th>Total</th>
                                <th className="text-center">
                                  {result.tableData
                                    .reduce(
                                      (sum, row) => sum + parseFloat(row.oldDA),
                                      0
                                    )
                                    .toFixed(0)}
                                </th>
                                <th className="text-center">
                                  {result.tableData
                                    .reduce(
                                      (sum, row) => sum + parseFloat(row.newDA),
                                      0
                                    )
                                    .toFixed(0)}
                                </th>
                                <th className="text-center">
                                  {result.tableData
                                    .reduce(
                                      (sum, row) =>
                                        sum + parseFloat(row.difference),
                                      0
                                    )
                                    .toFixed(0)}
                                </th>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* <div className="mb-3">
                    <p className="text-black mb-2 font-semibold">
                      {formData.differenceMonths} महिन्याचा महागाई भत्ता फरक
                    </p>
                    <input
                      type="text"
                      className="form-control"
                      value={result.totalDADifference || "NaN"}
                      readOnly
                    />
                  </div> */}
                </div>
                {/* Sub Section Ends */}
                <div className="mt-3">
                  <div className="row">
                    <div className="col-lg-3 m-auto text-center ">
                      <button
                        onClick={() => generatePDF()}
                        className="bg-blue-500 w-100 text-white px-4 py-2 rounded hover:bg-blue-600"
                      >
                        Print
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default DACalculator;
